import { QuestionConfigBasicsDto } from "@green0meter/api-client";
import React, { Dispatch, FC, SetStateAction } from "react";
import { Control, FieldValues } from "react-hook-form";
import { useTranslation } from "react-i18next";

import Paging from "./components/Paging";
import Row from "./components/Row";

import {
  Table as TableWrapper,
  TableContainer,
  TableHead,
  TableRow,
  TableBody,
  TableCell,
} from "@components/base";

interface Table {
  questions: QuestionConfigBasicsDto[];
  page: number;
  setPage: Dispatch<SetStateAction<number>>;
  control: Control<FieldValues, string>;
}

const Table: FC<Table> = ({ questions, page, setPage, control }) => {
  const { t } = useTranslation();

  return (
    <>
      <TableContainer>
        <TableWrapper size="small">
          <TableHead>
            <TableRow>
              <TableCell>{t("questionsTable.select")}</TableCell>
              <TableCell>{t("questionsTable.id")}</TableCell>
              <TableCell>{t("questionsTable.title")}</TableCell>
              <TableCell>{t("questionsTable.inputType")}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {questions.map((question) => (
              <Row
                question={question}
                control={control}
                key={`question-item-${question.id}`}
              />
            ))}
          </TableBody>
        </TableWrapper>
      </TableContainer>
      <Paging page={page} setPage={setPage} />
    </>
  );
};

export default Table;
